<template>
  <button :disabled="disabled" :class="[
    outline ? 'border' : '',
    bg_color,
    full_width ? 'w-full' : '',
    text_color,
    outline ? border_color : '',
    'py-3 rounded-lg text-sm font-bold uppercase shadow outline-none',
  ]" @click="click" type="button">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "v-button",
  props: {
    theme: {
      type: String,
      default: "success",
    },
    href: {
      type: String,
      default: null,
      required: false,
    },
    disabled: {
      type: Boolean,
    },
    full_width: {
      type: Boolean,
      default: true,
    },
    outline: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    bg_color() {
      if (this.disabled) return "bg-grey";

      if (this.outline) return "bg-white";

      const selected_theme = this.themes[this.theme];
      return selected_theme?.default || "bg-grey";
    },

    text_color() {
      if (this.disabled) return "text-white";

      if (this.outline) {
        return this.theme === "secondary"
          ? "text-primary"
          : `text-${this.theme}`;
      }

      return this.theme === "secondary"
        ? "text-primary"
        : "text-white";
    },

    border_color() {
      if (!this.outline) return "";

      if (this.disabled) return "border-grey";

      return this.theme === "secondary"
        ? "border-primary"
        : `border-${this.theme}`;
    }
  },
  data() {
    return {
      selected_theme: null,
      themes: {
        success: {
          default: "bg-success",
          disabled: "bg-success-disabled",
        },
        error: {
          default: "bg-error",
          disabled: "bg-error-disabled",
        },
        warning: {
          default: "bg-warning",
          disabled: "bg-warning-disabled",
        },
        info: {
          default: "bg-info",
          disabled: "bg-info-disabled",
        },
        secondary: {
          default: "bg-secondary",
          disabled: "bg-secondary-disabled",
        },
      },
    };
  },
  mounted() {
    this.selected_theme = this.themes[this.theme];
  },
  methods: {
    click() {
      if (this.href != null) {
        this.$router.push(this.href);
      }
      this.$emit("clicked");
    },
  },
  watch: {
    theme(theme) {
      this.selected_theme = this.themes[theme];
    },
  },
};
</script>
